// extracted by mini-css-extract-plugin
export default {"formGroup":"form-group_formGroup__aGjSJ","buttons":"form-group_buttons__qsNfU"};